import React from 'react';
import styled from 'styled-components';
import { Box } from 'grommet';
import TextInput from '../../inputs/TextInput';
import { Menu } from 'grommet-icons';

const Avatar = styled.div`
  background: grey;
  border-radius: 50%;
  height: 25px;
  width: 25px;
`;

const HeaderContainer = styled.div`
  padding: 8px;
  height: 50px;
  width: 1100px;
  max-width: 100%;
  margin: auto;
`;

const LogoContainer = styled(Box)`
  width: 40px;
  height: 20px;
  background: #efefef;
  display: inline;
  padding: 8px 20px;
  border-radius: 20px;
`;

class Header extends React.PureComponent {
  render() {
    return (
      <HeaderContainer>
        <Box alignContent="between" direction="row">
          <Box alignContent="between" direction="row" basis="2/4">
            <Box basis="1/6">
              <Menu style={{ display: 'inline' }} />{' '}
            </Box>
            <Box basis="2/6">
              <LogoContainer>Logo</LogoContainer>
            </Box>
            <Box basis="3/6">
              <TextInput />
            </Box>
          </Box>
          <Box basis="1/4" />
          <Box basis="1/4">
            <Avatar />
          </Box>
        </Box>
      </HeaderContainer>
    );
  }
}

export default Header;
